export const IconRight = () => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5625 5.27344L20.4375 11.8359C20.6328 12.0312 20.75 12.2656 20.75 12.5391C20.75 12.7734 20.6328 13.0078 20.4375 13.2031L13.5625 19.7656C13.2109 20.1172 12.5859 20.1172 12.2344 19.7266C11.8828 19.375 11.8828 18.75 12.2734 18.3984L17.4688 13.4766H4.1875C3.64062 13.4766 3.25 13.0469 3.25 12.5391C3.25 11.9922 3.64062 11.6016 4.1875 11.6016H17.4688L12.2734 6.64062C11.8828 6.28906 11.8828 5.66406 12.2344 5.3125C12.5859 4.92188 13.1719 4.92188 13.5625 5.27344Z"
          fill="#353535"
        />
      </svg>
    );
};